//import { useSnackbar } from 'notistack'

export const ErrorList = ({errors}) => {
    /* const { enqueueSnackbar } = useSnackbar();
    errors.map(error => (
        enqueueSnackbar(error.stack, {variant: 'error'})
      )) */
    return null
}